import React, { useMemo } from 'react';
import { Text } from '@ui-kitten/components';
import mergeStyles from '@alucio/lux-ui/src/components/util/mergeStyles';
export var DNACategoriesEnum;
(function (DNACategoriesEnum) {
    DNACategoriesEnum["h1"] = "h1";
    DNACategoriesEnum["h2"] = "h2";
    DNACategoriesEnum["h3"] = "h3";
    DNACategoriesEnum["h4"] = "h4";
    DNACategoriesEnum["h5"] = "h5";
    DNACategoriesEnum["b1"] = "p1";
    DNACategoriesEnum["b2"] = "p2";
    DNACategoriesEnum["c1"] = "c1";
    DNACategoriesEnum["c2"] = "c2";
    DNACategoriesEnum["c3"] = "c3";
    DNACategoriesEnum["label"] = "s1";
    DNACategoriesEnum["caption"] = "s2";
})(DNACategoriesEnum || (DNACategoriesEnum = {}));
export const DNACategoriesKeys = Object.keys(DNACategoriesEnum);
const S = {
    bold: {
        fontWeight: 700,
    },
};
export const DNAText = (props) => {
    const { children, h1, h2, h3, h4, h5, b1, b2, c1, c2, c3, label, caption, bold, ...rest } = props;
    const category = useMemo(() => {
        const [foundCategoryProp] = Object
            .entries(props)
            .find(([key, value]) => value && DNACategoriesEnum[key]) ??
            [];
        return foundCategoryProp
            ? { category: DNACategoriesEnum[foundCategoryProp] }
            : {};
    }, [h1, h2, h3, h4, h5, b1, b2, c1, c2, c3, label, caption]);
    return (<Text {...rest} {...category} style={mergeStyles(rest, [S.bold, bold])}>
      {children}
    </Text>);
};
export default DNAText;
//# sourceMappingURL=DNAText.js.map